import React, { useState } from 'react';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import DateRangeIcon from '@material-ui/icons/DateRange';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import FlagIcon from '@material-ui/icons/Flag';
import axios from 'axios';
import { API_HOST } from '../../consts';
import { toast } from 'react-toastify';

const ClassPlanCard = (props) => {
  const {
    title,
    duration,
    moments,
    subject,
    grade,
    criado,
    color,
    img,
    id,
    turma,
    fetchInfo,
    createdBy,
    meId,
    personalAssistent = false
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = async (id) => {
    await axios
      .put(`${API_HOST}/openai/api-response/${id}/request_delete`)
      .then((res) => {
        toast.success('Plano deletado com sucesso.');
        fetchInfo(meId);
      })
      .catch((err) => {
        console.error(err);
        toast.error('Ocorreu um erro ao excluir este plano.');
      });
    window.location.reload();
  };

  const handleCopy = async (id) => {
    await axios
      .get(`${API_HOST}/openai/api-response/${id}/copy`)
      .then(() => {
        toast.success('Plano copiado com sucesso.');
        fetchInfo(meId);
      })
      .catch((err) => {
        console.error(err);
        toast.error('Ocorreu um erro ao copiar este plano.');
      });
    window.location.reload();
  };

  const editRoute = (idPlan) => {
    window.location.href = personalAssistent
      ? `/assistente-pessoal-retorno-v0/${idPlan}`
      : `/personal-edit/${idPlan}`;
  };

  const viewPlan = (idPlan) => {
    window.location.href = personalAssistent
      ? `/assistente-pessoal-retorno-v0/${idPlan}`
      : `/personal-view/${idPlan}`;
  };

  const printOutRoute = (idPlano) => {
    window.location.assign(
      personalAssistent
        ? `/assistente-pessoal-retorno-v0/${idPlano}`
        : `/personal-edit/${idPlano}`
    );
  };

  const permissionEdit = meId && (
    (meId.logged_group.includes('DRE') || meId.logged_group.includes('COORDENADOR')) ?
    false : meId.id == createdBy ? true : false
  )

  const exportPlan = () => {
    const token = localStorage.getItem('token');
    const cacheControl = new Date().getTime();
    const exportLink = `${API_HOST}/export_item/lesson_plan/${id}?token=${token}&template_id=${"Lesson-Plan"}&_=${cacheControl}`;
    window.open(exportLink);
  };

  return (
    <div>
      <div
        style={{
          width: '839px',
          height: '157px',
          borderRadius: '16px',
          border: '1px solid #EBEBEB',
          background: '#FFFFFF',
          marginBottom: '1em'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyItems: 'center',
            justifyContent: 'start',
            padding: '0px 10px',
            gap: '50px',
            height: '100%'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              boxShadow: '0px 1px 18px 0px #acacac40'
            }}
          >
            <img src={img ? img : ''} width="98px" height="138px" />
          </div>
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '665px' }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1em'
              }}
            >
              <h1
                style={{
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#262930',
                  fontFamily: 'Public Sans'
                }}
              >
                {title ? title : 'Sem título de capítulo fornecido'}
              </h1>
              <IconButton
                onClick={handleClick}
                style={{ backgroundColor: 'transparent', padding: '0' }}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {/* <MenuItem onClick={handleClose}>Baixar Plano de Aula</MenuItem> */}
                <MenuItem onClick={() => printOutRoute(id)}>Imprimir</MenuItem>
                {permissionEdit && (
                  <>
                    <MenuItem onClick={() => editRoute(id)}>Editar</MenuItem>
                    <MenuItem onClick={() => handleCopy(id)}>Copiar</MenuItem>
                  </>
                )}
                <MenuItem onClick={() => viewPlan(id)}>Visualizar</MenuItem>
                <MenuItem onClick={() => (exportPlan())}>Baixar Doc</MenuItem>
                <div
                  style={{
                    border: '.5px solid #EDEDED',
                    width: '100%',
                    margin: '.5em 0'
                  }}
                />
                {permissionEdit && (
                  <MenuItem
                    onClick={() => handleDelete(id)}
                    style={{ color: 'red' }}
                  >
                    Excluir
                  </MenuItem>
                )}
              </Menu>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '1em',
                  fontWeight: '500'
                }}
              >
                <DateRangeIcon
                  style={{
                    marginRight: '.2em',
                    color: '#727780',
                    fontSize: '16px'
                  }}
                />
                <p
                  style={{
                    marginBottom: '0',
                    color: '#4A4F58',
                    fontSize: '14px'
                  }}
                >
                  Atualizado em: {criado ? criado : 'Não fornecido'}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '1em',
                  fontWeight: '500'
                }}
              >
                <AccessAlarmIcon
                  style={{
                    marginRight: '.2em',
                    color: '#727780',
                    fontSize: '16px'
                  }}
                />
                <p
                  style={{
                    marginBottom: '0',
                    color: '#4A4F58',
                    fontSize: '14px'
                  }}
                >
                  Tempo de duração: {duration ? duration : 'Não fornecido'}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: '500'
                }}
              >
                <FlagIcon
                  style={{
                    marginRight: '.2em',
                    color: '#727780',
                    fontSize: '16px'
                  }}
                />
                <p
                  style={{
                    marginBottom: '0',
                    color: '#4A4F58',
                    fontSize: '14px'
                  }}
                >
                  Quantidade de momentos: {moments ? moments : 'Não fornecido'}
                </p>
              </div>
            </div>
            <div
              style={{
                border: '.5px solid #CFD2D9',
                width: '100%',
                margin: '1em 0'
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  display:'flex',
                  alignItems:'center',
                  justifyContent:'center',
                  border: 'none',
                  height: '24px',
                  background: `${color}`,
                  borderRadius: '28px',
                  padding: '0px 16px 0px 16px',
                  marginRight: '.5em',
                  color: 'white',
                  fontFamily: 'Public Sans'
                }}
              >
                {subject ? subject : 'Não fornecido'}
              </div>
              <div
                style={{
                  display: 'flex'
                }}
              >
                {/* <p style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#4A4F58',
                  paddingRight: '.5em',
                  borderRight: '1px solid #4A4F58',
                  margin: '0',
                  marginRight: '.5em',
                }}>Atividade</p> */}
                <p
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#4A4F58',
                    margin: '0',
                    marginRight: '.5em'
                  }}
                >
                  {grade ? grade : 'Não fornecido'} {turma}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassPlanCard;
